/**
 * Flattens a multidimensional object
 * @param {object} ob the source object
 * @returns {{}}w
 */
export function flattenObject(ob) {
  const toReturn = {};

  for (const i in ob) {
    if (!ob.hasOwnProperty(i)) {
      continue;
    }

    if ((typeof ob[i]) === 'object' && !Array.isArray(ob[i])) {
      const flatObject = flattenObject(ob[i]);
      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) {
          continue;
        }

        toReturn[x] = flatObject[x];
      }
    }
    else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
}


// WEBPACK FOOTER //
// ./src/utils/object/flatten.utils.ts